import {dedupingMixin} from '@polymer/polymer/lib/utils/mixin';
import {isMobile} from '@aoflmkt/is-mobile';

/**
 * Mixin function for IsMobileMixin class
 */
export default dedupingMixin((superClass) => {
  /**
   * @class IsMobileMixin
   * @extends superClass
   */
  class IsMobileMixin extends superClass {
    /**
     * Creates an instance of IsMobileMixin.
     * @memberof IsMobileMixin
     */
    constructor(...args) {
      super(...args);

      if (isMobile.any === true) {
        this.classList.add('is-mobile');
      }
    }
  }
  return IsMobileMixin;
});
